var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgECommerce({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.09,28.4l-3.53.06c1.25.11,2.24,1.05,2.5,2.26.27,1.27-.49,2.53-1.58,3.04-1.25.59-2.6.15-3.37-.86-.82-1.07-.76-2.5.14-3.5.52-.58,1.13-.83,1.85-.96h-11.68c1.53.18,2.62,1.46,2.54,2.93s-1.33,2.68-2.82,2.65-2.65-1.19-2.74-2.65,1.06-2.8,2.54-2.91l-1.74-.06c-1.48-.05-2.58-1.23-2.69-2.69-.05-.62.12-1.34-.02-1.97l-3.23-14.61c-.09-.43-.31-1.09-.76-1.19-1.06-.23-2.37.29-2.5-1.02-.09-.94,1.44-1.11,2.7-.85,1.12.23,2.01,1.2,2.26,2.3l.74,3.23h21.33c.53,0,1.07.51.94,1.05l-2.28,9.21c-.38,1.55-1.62,2.8-3.31,2.8h-13.98s.02,1.19.02,1.19c0,.4.5.69.92.69h17.7c.57,0,.91.44.93.88s-.26.96-.87.97ZM29.79,21.84l2.1-8.35H12.12s2.08,9.34,2.08,9.34h14.42c.46-.01,1.07-.55,1.18-.99ZM18.14,31.23c0-.52-.42-.94-.94-.94s-.94.42-.94.94.42.94.94.94.94-.42.94-.94ZM30.27,31.23c0-.52-.42-.94-.94-.94s-.94.42-.94.94.42.94.94.94.94-.42.94-.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/e-commerce.b7948b28bd6688b56d25899e2cdbd9d0.svg";
export { ForwardRef as ReactComponent };